import { SelectableBillingPeriodTypes } from '@constants/billingPeriods'
import { CurrencyType } from '@constants/currencies'
import { PlanNamesTypes, PlanRecordKeyTypes } from '@constants/plans'
import { useStyles } from '@hooks/useStyles'
import { Panel, Spacer } from '@ui-kit'
import { Dispatch, FC, SetStateAction } from 'react'
import { Column } from 'simple-flexbox'

import { Addons } from './components/Addons'
import { Header } from './components/Header'
import { Highlighted } from './components/Highlighted'
import { Limits } from './components/Limits'
import { PriceLabel } from './components/PriceLabel'
import styles from './Plan.module.scss'

interface PlanProps {
  recordKey: PlanRecordKeyTypes
  name: PlanNamesTypes
  isHighlighted?: boolean
  currency: CurrencyType
  price: number
  isCurrent: boolean
  billingPeriod: SelectableBillingPeriodTypes
  annualSavingPrice: number
  isFreePlan?: boolean
  setPlanTypeName?: Dispatch<SetStateAction<PlanRecordKeyTypes>>
}

export const Plan: FC<PlanProps> = ({
  recordKey,
  name,
  isHighlighted,
  currency,
  price,
  isCurrent,
  billingPeriod,
  annualSavingPrice,
  isFreePlan,
  setPlanTypeName
}) => {
  const panelStyles = useStyles({
    [styles.plan__panel]: true,
    [styles['plan__panel--highlighted']]: isHighlighted
  })

  return (
    <Column className={styles.plan__wrapper}>
      {isHighlighted ? <Highlighted /> : null}

      <Panel
        className={panelStyles}
        border='neutral-2'
        surface={0}
        padding={{ x: 30, y: 20 }}
        data-testid={recordKey}
      >
        <Header name={name} isCurrentPlan={isCurrent} />

        <Spacer space={20} />

        <PriceLabel
          currency={currency}
          price={price}
          billingPeriod={billingPeriod}
          annualSavingPrice={annualSavingPrice}
          isFreePlan={isFreePlan}
        />

        <Spacer space={20} />

        <Limits recordKey={recordKey} setPlanTypeName={setPlanTypeName} />

        <Spacer space={20} />

        {/* TODO: */}
        <p>BUTTON</p>

        <Spacer space={20} />

        <Addons
          recordKey={recordKey}
          currency={currency}
          billingPeriod={billingPeriod}
        />
      </Panel>
    </Column>
  )
}

Plan.displayName = 'CheckoutPlansPlanPanelsPlan'
